// Global Settings Pickers
import '@adornis/buildify/client/components/x-buildify-aspect-ratio-picker.js';
import '@adornis/buildify/client/components/x-buildify-border-picker.js';
import '@adornis/buildify/client/components/x-buildify-border-radius-picker.js';
import '@adornis/buildify/client/components/x-buildify-color-picker.js';
import '@adornis/buildify/client/components/x-buildify-file-selection.js';
import '@adornis/buildify/client/components/x-buildify-permission-selection.js';
import '@adornis/buildify/client/components/x-buildify-size-picker.js';
import '@adornis/buildify/client/components/x-buildify-spacing-picker.js';
import '@adornis/buildify/client/components/x-buildify-width-picker.js';
// --------------------------------------------------------------------------------

// Other components
import '@adornis/buildify/client/components/x-icon-button.js';
// --------------------------------------------------------------------------------

import '@adornis/buildify/client/components/x-buildify-global-settings.js';
import { createComponentsFromChemistryBase } from '@adornis/chemistry/elements/x-components.js';

createComponentsFromChemistryBase(
  // pickers
  'x-buildify-global-settings-color-picker',
  'x-buildify-global-settings-spacing-picker',
  'x-buildify-global-settings-border-radius-picker',
  'x-buildify-global-settings-width-picker',
  'x-buildify-global-settings-border-picker',
  'x-buildify-spacing-picker',
  'x-buildify-color-picker',
  'x-buildify-size-picker',
  'x-buildify-width-picker',
  'x-buildify-border-radius-picker',
  'x-buildify-border-picker',
  'x-buildify-aspect-ratio-picker',
  'x-buildify-file-selection',
  'x-buildify-permission-selection',
  // other components
  'x-icon-button',
);
